module.exports = __webpack_public_path__ + "img/jpg.9aff6d1a.svg";